import Analytics from '@components/charts/analytics/Analytics'
import RegistrationOverview from '@components/overview/Overview'
import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import { ProductType } from '@models/Product'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Permission } from '@utils/permissions'
import { Col, Space } from 'antd'
import { Dayjs } from 'dayjs'

const CommunityPage = () => {
  return (
    <AnalyticsProvider>
      <Page permissions={Permission.viewOverview} noWrapWithCol>
        <Col span={24}>
          <PageTitle
            title={'Registration'}
            level={4}
            toolbar={
              <Space>
                <Analytics.Product
                  showOnlyTypes={[
                    ProductType.All,
                    ProductType.App,
                    ProductType.Chatbot,
                  ]}
                />
                <Analytics.Date
                  rangePresets={Analytics.rangesPresets.venue}
                  defaultValue={
                    Analytics.rangesPresets.venue![0].value as [Dayjs, Dayjs]
                  }
                />
              </Space>
            }
          />
        </Col>
        <Col span={24}>
          <RegistrationOverview.Chart />
        </Col>
      </Page>
    </AnalyticsProvider>
  )
}

export default CommunityPage
